import React from "react";
import TrimbleMaps from "@trimblemaps/trimblemaps-js";
import {
  Button,
  Menu,
  MenuItem,
  Fade,
  withStyles,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { SavePreferences } from "../../utilities/appHelper";
import { withUserProfile } from "../../userProfile/userProfileContext";
import {compose} from "recompose";

// Handle weather alert click popup doesn't open on marker click by checking if nodeName === "CANVAS", for markers it would be div or some part of svg
const onWeatherClicked =
  TrimbleMaps.WeatherAlertClickControl.prototype._onClick;
TrimbleMaps.WeatherAlertClickControl.prototype._onClick = function (event) {
  if (event.originalEvent.target.nodeName === "CANVAS") {
    onWeatherClicked.call(this, event);
  }
};
class MapView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      isTrafficVisible: false,
      isWeatherAlertVisible: false,
      isWeatherFilterVisible: false,
    };
    this.map = null;
    this.weatherFilterCtrl = null;
    this.weatherAlertClickCtrl = null;
  }

  componentDidMount() {
    this.props.eventHub?.on(`set_${this.props.mapId}`, this.setMap);
    
  }

  componentWillUnmount() {
    this.props.eventHub?.off(`set_${this.props.mapId}`, this.setMap);;
    this.map?.off("weatheralert",this.onWeatherAlertLoaded );
  }

  setMap = (map) => {
    this.map = map;
    const {
      isTrafficVisible,
      isWeatherAlertVisible,
      isWeatherFilterVisible,
    } = this.getMapViewOptionsPreferences();
    this.setState({
      isTrafficVisible,
      isWeatherAlertVisible,
      isWeatherFilterVisible,
      isWeatherLayerLoaded: isWeatherAlertVisible,
    });
    this.map.on("weatheralert",this.onWeatherAlertLoaded );
    if (isWeatherAlertVisible) {
      this.weatherAlertClickCtrl = new TrimbleMaps.WeatherAlertClickControl();
      this.map.addControl(this.weatherAlertClickCtrl);
    }
    this.addWeatherFilterVisibilityControl(isWeatherFilterVisible);
  };

  // Show/hide weather filter when loading map for first time
  onWeatherAlertLoaded = () => {
    this.setWeatherFilterVisibility(this.state.isWeatherFilterVisible)
  }


  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  setTrafficAndAlertVisibility = (isTrafficVisible, isWeatherAlertVisible) => {
    isTrafficVisible && this.map.setTrafficVisibility(isTrafficVisible);
    isWeatherAlertVisible && this.map.setWeatherAlertVisibility(isWeatherAlertVisible);
  }

  getMapViewOptionsPreferences = () => {
    const {
      isTrafficVisible,
      isWeatherAlertVisible,
      isWeatherFilterVisible = false
    } = this.props.userData.userProfile?.columnPref?.[`${this.props.mapId}_Config`] ?? {};
    /* for new user both traffic/weather will be enabled */
    const isDefaultTrafficVisible = isTrafficVisible ?? this.props.trafficWeatherVisibility;
    const isDefaultWeatherAlertVisible =
      isWeatherAlertVisible ?? this.props.trafficWeatherVisibility;
    if (this.props.trafficWeatherVisibility) {
      this.setTrafficAndAlertVisibility(isDefaultTrafficVisible, isDefaultWeatherAlertVisible);
    }
    return {
      isTrafficVisible: isDefaultTrafficVisible,
      isWeatherAlertVisible: isDefaultWeatherAlertVisible,
      isWeatherFilterVisible
    };
  };

  saveMapViewOptionsPreferences = () => {
    let { columnPref, userId } = this.props.userData.userProfile;
    const {
      isTrafficVisible,
      isWeatherAlertVisible,
      isWeatherFilterVisible,
    } = this.state;
    if (!columnPref) {
      columnPref = {};
    }
    const storedConfig = columnPref[`${this.props.mapId}_Config`] ?? {};
    SavePreferences({
      name: `${this.props.mapId}_Config`,
      config: {
        ...storedConfig,
        ...{
          isTrafficVisible,
          isWeatherAlertVisible,
          isWeatherFilterVisible: !isWeatherAlertVisible? false: isWeatherFilterVisible
        }
      },
      userColumnPref: columnPref,
      userId
    });
  };

  toggleTrafficVisibility = () => {
    const isTrafficVisible = !this.state.isTrafficVisible;
    this.map.setTrafficVisibility(isTrafficVisible);
    this.setState({
      isTrafficVisible,
    }, this.saveMapViewOptionsPreferences);
  };

  toggleWeatherVisibility = () => {
    const isWeatherAlertVisible = !this.state.isWeatherAlertVisible;
    if (isWeatherAlertVisible) {
      this.weatherAlertClickCtrl = new TrimbleMaps.WeatherAlertClickControl();
      this.map.addControl(this.weatherAlertClickCtrl);
    } else {
      this.setState({
        isWeatherLayerLoaded: false,
      });
      if (this.weatherAlertClickCtrl) {
        this.map.removeControl(this.weatherAlertClickCtrl);
        this.weatherAlertClickCtrl = null;
      }
      
    }
     
    this.map.setWeatherAlertVisibility(isWeatherAlertVisible);
    this.setWeatherFilterVisibility(isWeatherAlertVisible && this.state.isWeatherFilterVisible)
    this.setState({
      isWeatherAlertVisible,
    }, this.saveMapViewOptionsPreferences);
  };

  addWeatherFilterVisibilityControl = (isWeatherFilterVisible) => {
      this.weatherFilterCtrl = new TrimbleMaps.WeatherAlertFilterControl();  
      this.map.addControl(this.weatherFilterCtrl, "top-left");
      this.setWeatherFilterVisibility(isWeatherFilterVisible)
  }

  setWeatherFilterVisibility = (isWeatherFilterVisible) => {
    this.weatherFilterCtrl._container.style.display = isWeatherFilterVisible ? "block" : "none"
    this.setState({
      isWeatherFilterVisible,
    }, this.saveMapViewOptionsPreferences);
  }

  toggleWeatherFilterVisibility = () => {
    this.setWeatherFilterVisibility(!this.state.isWeatherFilterVisible)
  };

  removeMapControl = (control) => {
    if (control) {
      this.map.removeControl(control);
      // control = null;
    }
  };

  render() {
    if (!this.map) {
      return null;
    }
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const { classes } = this.props;

    const {
      isTrafficVisible,
      isWeatherAlertVisible,
      isWeatherFilterVisible,
    } = this.state;
    return (
      <div style={{ float: "left", marginTop: 2 }}>
        <Button
          aria-controls="fade-menu"
          aria-haspopup="true"
          className={classes.button}
          onClick={this.handleClick}
        >
          Map Views
          <ExpandMore className={classes.icon} />
        </Button>
        <Menu
          id="fade-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={this.handleClose}
          TransitionComponent={Fade}
          elevation={1}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          MenuListProps={{
            classes: {
              root: classes.menuList,
            },
          }}
        >
          <MenuItem classes={{ root: classes.menuItemRoot }}>
            <LabeledCheckbox
              label="Traffic"
              checkboxProps={{
                name: "traffic",
                checked: isTrafficVisible,
                onChange: this.toggleTrafficVisibility,
              }}
            />
          </MenuItem>
          <MenuItem classes={{ root: classes.menuItemRoot }}>
            <LabeledCheckbox
              label="Weather"
              checkboxProps={{
                name: "weather",
                checked: isWeatherAlertVisible,
                onChange: this.toggleWeatherVisibility,
              }}
            />
          </MenuItem>
          <MenuItem classes={{ root: classes.menuItemRoot }}>
            <LabeledCheckbox
              label="Weather Filter"
              checkboxProps={{
                disabled: !isWeatherAlertVisible,
                name: "weatherFilter",
                checked: isWeatherFilterVisible,
                onChange: this.toggleWeatherFilterVisibility,
              }}
            />
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

const checkBoxStyles = (theme) => ({
  checkBox: {
    padding: "2px 8px 2px 2px",
    color: theme.iconColor,
    "&$checkBoxDisabled": {
      color: theme.iconColor,
      opacity: 0.4,
      cursor: "not-allowed",
    },
  },
  checkBoxDisabled: {},
  labelRoot: {
    margin: 0,
    flex: 1,
    padding: 6,
  },
  label: {
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    "&$disabledLabel": {
      color: theme.TextColor,
      opacity: 0.4,
      cursor: "not-allowed",
    },
  },
  disabledLabel: {},
});

const LabeledCheckbox = withStyles(checkBoxStyles)(
  ({ classes, checkboxProps, ...labelProps }) => {
    return (
      <FormControlLabel
        classes={{
          label: classes.label,
          disabled: classes.disabledLabel,
          root: classes.labelRoot,
        }}
        {...labelProps}
        control={
          <Checkbox
            inputProps={{ "aria-label": labelProps.label }}
            color="primary"
            classes={{
              root: classes.checkBox,
              disabled: classes.checkBoxDisabled,
            }}
            {...checkboxProps}
          />
        }
      />
    );
  }
);

const styles = (theme) => ({
  button: {
    color: theme.TextColor,
    padding: "4px 8px",
    width: "100%",
    border: `1px solid ${theme.iconColor}`,
    fontSize: theme.textFontSize,
    "&:hover": {
      backgroundColor: theme.searchHoverBGColor,
    },
  },
  icon: {
    color: theme.iconColor,
    height: 16,
    width: 32,
  },
  menuItemRoot: {
    padding: 0,
    color: theme.TextColor,
    height: "auto",
    "&:hover": {
      background: theme.customMultiSelectColor,
    }
  },
  menuList: {
    padding: 8,
    backgroundColor: theme.ModalBGColor,
  },
});

export default compose(withStyles(styles), withUserProfile)(MapView);
